module.exports = __webpack_public_path__ + "static/pinkwaffle-960f81df598b5ce92a9bfaec5116eecd.jpeg";